<template>
  <div class="detail-body" v-loading="loading">
    <div class="spaceBetween">
      <div class="detail-title-1">Proposal Pool</div>
      <div class="spaceLeft search-form">
        <search-select @valChange="valChange($event, 'status')" label="Proposal results" :options="typeOptions"
          :default-value="searchParams.status" />
        <div class="sapceLeft search-item">
          <el-input
            v-model="searchParams.id"
            placeholder="No..."
            suffix-icon="el-icon-search"
            @change="getList"
          />
        </div>
      </div>
    </div>

    <div class="pool-card" v-for="(item, index) in tableList" :key="index">
      <el-row class="pool-card_head">
        <el-col :xs="24" :sm="24" :md="8" :lg="8">
          <div class="spaceLeft">
            <span style="color: #6b6b6b; margin-right: 0.08rem">Proposal No : </span>
            <span> {{ item.id }}</span>
            <vote-status-comp
              :status.sync="item.status"
              :over.sync="item.over"
              :cumulative.sync="item.vote"
              :threshold.sync="threshold"
            />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8">
          <template v-if="item.myVote > 0">
            <span class="c1">My vote:</span>
            <big-number :number="item.myVote" class="c2" />
            <span class="c1">UNIT</span>
          </template>
          <span v-else>You haven't voted yet!</span>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" style="text-align: right">
          <span>End Block:</span>
          <span>{{ item.endBlock }}</span>
        </el-col>
      </el-row>
      <el-row class="pool-card_body">
        <el-col :xs="24" :sm="24" :md="10" :lg="10">
          <div class="right-border">
            <div>
              <voteFromTo :title.sync="item.title" :desc.sync="item.description" />
            </div>
            <div style="margin-top: 0.44rem">
              <span class="c1">Proposer :</span>
              <span class="c2">{{ item.proposer }}</span>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="10" :lg="10" class="right-border">
          <div class="progress_box" style="width: 85%; margin: 0 auto">
            <voteProgress
              :cumulative.sync="item.totalWeight"
              :threshold.sync="item.threshold"
            />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="4" :lg="4">
          <div class="pool-btn-box">
            <div class="btn1" @click="handleVote(item)" v-if="showVote(item)">Vote</div>
            <div class="btn2" @click="voteDetail(item)">
              <svg-icon icon-class="vote" />
              Vote Details
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div
      v-if="tableList.length == 0"
      style="
        text-align: center;
        padding: 0.32rem;
        color: #999;
        font-size: 0.18rem;
        background: #fafafa;
        border-radius: 0.16rem;
        margin-top: 0.16rem;
      "
    >
      No Data
    </div>
    <pagination
      v-if="queryParams.total > 0"
      :total.sync="queryParams.total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.pageSize"
      @pagination="getList()"
    />
    <voteDialog ref="voteDialog" @success="refresh" />
  </div>
</template>

<script>
import voteDialog from "./voteDialog.vue";
import voteStatusComp from "@/views/governance/components/voteStatusComp.vue";
import voteProgress from "@/views/governance/components/voteProgress.vue";
import { proposalslist } from "@/api/dao.js";
import voteFromTo from "@/views/governance/components/voteFromTo.vue";
export default {
  components: { voteDialog, voteStatusComp, voteProgress, voteFromTo },
  data() {
    return {
      loading: false,
      searchParams: {
        id: undefined,
        status: "1",
      },
      statusArr: [0, 1],
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 5,
      },
      tableList: [],
      typeOptions: this.$store.getters.proposalStatus,
      threshold: undefined,
    };
  },
  computed: {},
  methods: {
    init() {
      this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
      this.contractDaoAddress = this.$store.getters.contractMap["contractDao"].address;
      // this.getThreshold();
      this.getList();
    },
    valChange(data, prop) {
      console.log(data)
      this.searchParams[prop] = data.value;
      this.queryParams = {
        total: 0,
        page: 1,
        pageSize: 5,
      };
      if (data.value === "1") {
        this.statusArr = [0, 1];
      } else if (data.value === "2") {
        this.statusArr = [4, 5, 7, 8];
      } else if (data.value === "3") {
        this.statusArr = [2, 3, 6];
      } else {
        this.statusArr = [0, 1, 2, 3, 4, 5, 6, 7, 8];
      }
      this.getList();
    },
    getList() {
      this.loading = true;
      proposalslist({
        page: this.queryParams.page,
        pageSize: this.queryParams.pageSize,
        id: this.searchParams.id,
        status: this.statusArr,
        voter: this.$store.getters.metaMaskObj.account,
      })
        .then((res) => {
          let list = (res.result && res.result.list) || [];
          let reqArr = [];
          list.forEach((item) => {
            reqArr.push(this.getThreshold(item));
          });
          Promise.all(reqArr).then(() => {
            /*list.forEach(item => {
            if(item.curBlock >= item.endBlock) {
              if (item.totalWeight >= +item.threshold) {
                 item.status = 4;
              }
              else {
                item.status = 2;
              }
            }
            else{
              item.status = 1;
            }
          })*/
            this.tableList = list;
            //console.log(this.tableList)
            this.loading = false;
          });
          this.queryParams.total = (res.result && res.result.total) || 0;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    async getThreshold(row) {
      try {
        row.curBlock = await web3.eth.getBlockNumber();
        row.threshold = await this.contractDao.methods
          .quorum(row.endBlock)
          .call({ from: this.$store.getters.metaMaskObj.account });
        return row;
      } catch (e) {
        console.log(e);
        row.threshold = 0;
        return row;
      }
    },
    getMyVote(list = []) {
      let myVote = 0;
      // let accountItem = list.find(i => i.proposer == this.$store.getters.metaMaskObj.account) || {};
      // myVote = accountItem.voteTotal || 0;
      return myVote;
    },
    showVote(data) {
      // let now = new Date().getTime();
      // return data.status == 1 && data.over * 1000 >= now;
      return data.status == 1;
    },
    handleVote(data) {
      if (this.getToken()) {
        if (data.proposer === this.$store.getters.metaMaskObj.account) {
          this.$message.error("You have already voted, please do not vote again.");
          return;
        }
        this.$refs.voteDialog.open({
          row: data,
          threshold: this.threshold,
        });
      } else {
        this.$message.warning("You must sign in to the wallet to view this page!");
      }
    },
    voteDetail(data) {
      this.$router.push({
        path: "/Governance/vote/Detail",
        query: {
          proposalId: data.proposalId,
        },
      });
    },
    refresh() {
      this.getList();
    },
  },
  created() {
    this.init();
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.c1 {
  color: #ffffff;
}
.c2 {
  color: #dce0e7;
}
.detail-title-1 {
  margin-bottom: 0.25rem;
}

.pool-card {
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266b 100%);
  border-radius: 0.08rem;
  font-size: 0.2rem;
  margin-bottom: 0.2rem;
  border: 1px solid #272D38;

  .pool-card_head {
    // padding: 0.16rem 0.56rem;
    height: 0.64rem;
    padding-left: 0.56rem;
    padding-right: 0.56rem;
    line-height: 0.64rem;
    color: #dce0e7;
    border-bottom: 1px solid #272D38;
  }

  .pool-card_body {
    padding: 0.24rem 0.56rem 0.3rem 0.56rem;
    color: #6b6b6b;

    .text-color-1 {
      color: #1f1f1f;
    }

    .text-num {
      font-size: 0.18rem;
      color: #4c4c4c;
      font-weight: bold;
    }

    .text-num-desc {
      font-size: 0.16rem;
      font-weight: normal;
      color: #aaaaaa;
      margin-bottom: 0.08rem;
    }

    .pool-btn-box {
      text-align: center;
      width: 2.56rem;
      font-size: 0.18rem;
      font-family: PlusJakartaDisplay-Medium, PlusJakartaDisplay;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.4rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      padding-top: 0.2rem;

      .btn1 {
        width: 1.84rem;
        height: 0.4rem;
        background: #225bfc;
        border-radius: 0.06rem;
        margin-bottom: 0.2rem;
        cursor: pointer;
      }
      .btn2 {
        width: 1.84rem;
        height: 0.4rem;
        background: rgba(255, 255, 255, 0.1);
        border: 1px solid rgba(255, 255, 255, 0.2);
        border-radius: 0.06rem;
        cursor: pointer;
      }
    }

    .right-border {
      border-right: 0.01rem solid #272D38;
    }
  }
}
.progress_box /deep/ .detail-item-label {
  color: #dce0e7;
}
.progress_box /deep/ .text-num .text-bold {
  color: #ffffff;
}
</style>
